<template>
    <div class="ui-content dashboard">
        <v-card class="mx-auto normal-card subscription-details">
            <div class="subscription-padding">
                <div class="subscription-details-title">
                    Subscription Details:
                </div>
                <template v-if="!subscriptionNewModule">
                    <div class="subscription-details-btm-border">
                        <div class="subscription-details-row">
                            <div class="subscription-details-col">
                                <div class="subscription-details-label">
                                    Number of Student Licenses:
                                </div>
                                <div class="subscription-details-info">
                                    {{ myInstitute.student_count }}
                                </div>
                            </div>
                            <div class="subscription-details-col">
                                <div class="subscription-details-label-1">
                                    Licenses Valid Till:
                                </div>
                                <div class="subscription-details-info">
                                    {{ getExpiryDate() }}
                                </div>
                            </div>
                            <div class="subscription-details-col">&nbsp;</div>
                            <div class="subscription-details-col">
                                <div class="subscription-details-label">
                                    Active Students:
                                </div>
                                <div class="subscription-details-info">
                                    {{ myInstitute.students_active }}
                                </div>
                            </div>
                            <div class="subscription-details-col">
                                <div class="subscription-details-label-1">
                                    Unused Licenses:
                                </div>
                                <div class="subscription-details-info">
                                    {{ myInstitute.student_remaining_licenses }}
                                </div>
                            </div>
                            <div class="subscription-details-col">&nbsp;</div>
                            <div class="subscription-details-col">
                                <div class="subscription-details-label">
                                    Deactivated Students:
                                </div>
                                <div class="subscription-details-info">
                                    {{ myInstitute.students_deactive }}
                                </div>
                            </div>
                            <div class="subscription-details-col">
                                <div class="subscription-details-label-1">
                                    Monthly Licensing Fee:
                                </div>
                                <div class="subscription-details-info">
                                    ₹{{ myInstitute.monthly_license_fee }}
                                </div>
                            </div>
                            <div class="subscription-details-col">&nbsp;</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="subscription-details-btm-border">
                        <h5>{{subscriptionNewModule.description}}</h5>
                        <div class="subscription-details-row">
                            <template v-if="Number(subscriptionNewModule.no_of_licences)">
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Number of Student Licenses:</div>
                                    <div class="subscription-details-info">{{subscriptionNewModule.no_of_licences}}</div>
                                </div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Licenses Valid Till:</div>
                                    <div class="subscription-details-info">{{subscriptionNewModule.allowed_end_date}}</div>
                                </div>
                                <div class="subscription-details-col">&nbsp;</div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Active Students:</div>
                                    <div class="subscription-details-info">{{myInstitute.students_active}}</div>
                                </div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Unused Licenses:</div>
                                    <div class="subscription-details-info">{{subscriptionNewModule.unused_licenses}}</div>
                                </div>
                                <div class="subscription-details-col">&nbsp;</div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Deactivated Students:</div>
                                    <div class="subscription-details-info">{{myInstitute.students_deactive}} </div>
                                </div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Annual Licensing Fee:</div>
                                    <div class="subscription-details-info">  ₹{{subscriptionNewModule.per_student_amount}} </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Valid Till:</div>
                                    <div class="subscription-details-info">{{subscriptionNewModule.allowed_end_date}}</div>
                                </div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Total Amount:</div>
                                    <div class="subscription-details-info">  ₹{{subscriptionNewModule.total_amount}} </div>
                                </div>
                                <div class="subscription-details-col">&nbsp;</div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Allowed Downloads per Month:</div>
                                    <div class="subscription-details-info">  {{subscriptionNewModule.no_of_test_downloads}} </div>
                                </div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Downloads this Month:</div>
                                    <div class="subscription-details-info">  {{myInstitute.total_downloads || 0}} </div>
                                </div>
                                <div class="subscription-details-col">&nbsp;</div>
                            </template>
                            <div class="subscription-details-col">&nbsp;</div>
                        </div>
                    </div>
                </template>
                <div class="subscription-details-title">
                    Renew / Extend Subscription:
                </div>
                <div class="subscription-details-btm-border">
                    <div class="subscription-details-row">
                        <div class="subscription-details-col-1" v-if="Number(subscriptionNewModule.no_of_licences)">
                            <div>Number of Student Licenses:</div>
                            <div>
                                <v-text-field
                                    hide-details
                                    v-model="studentCount"
                                    type="Number"
                                    class="LicensesNumber"
                                ></v-text-field>
                            </div>
                        </div>
                        <div class="subscription-details-col-1">
                            <div>Duration (months):</div>
                            <div>
                                <v-text-field
                                    hide-details
                                    v-model="durationMonth"
                                    type="Number"
                                    class="LicensesNumber"
                                    step="12"
                                    min="12"
                                ></v-text-field>
                                <InputError v-if="error.durationMonth.type" :data="error.durationMonth" />
                            </div>
                            <div>
                                Licenses shall be valid till
                                {{
                                    renewalDetails &&
                                    renewalDetails.renewal_expiry_date
                                        ? renewalDetails.renewal_expiry_date
                                        : "-"
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                
                <div>
                    <div class="subscription-details-title">
                        Billing Details:
                    </div>
                    <div class="subscription-details-row">
                        <div class="subscription-details-col-new-1">
                            <div class="subscription-details-col-input-I">
                                <div class="billing-text-field">
                                    <v-text-field
                                        label="Billing Name"
                                        hide-details
                                        v-model="name"
                                        dense
                                        outlined
                                        class="required"
                                    ></v-text-field>
                                    <InputError :data="error.name" />
                                </div>
                                <div class="billing-text-field">
                                    <v-text-field
                                        label="Billing Address"
                                        hide-details
                                        v-model="address"
                                        dense
                                        outlined
                                        class="required"
                                    ></v-text-field>
                                    <InputError :data="error.address" />
                                </div>
                            </div>
                            <div class="subscription-details-col-input-I">
                                <div class="billing-text-field ">
                                    <v-text-field
                                        label="City"
                                        hide-details
                                        v-model="city"
                                        dense
                                        outlined
                                        class="required"
                                    ></v-text-field>
                                    <InputError :data="error.city" />
                                </div>
                                <div class="billing-text-field ">
                                    <v-text-field
                                        label="State"
                                        hide-details
                                        dense
                                        v-model="state"
                                        outlined
                                        class="required"
                                    ></v-text-field>
                                    <InputError :data="error.state" />
                                </div>
                            </div>
                            <div class="subscription-details-col-input-I">
                                <div class="billing-text-field">
                                    <v-text-field
                                        label="Pincode"
                                        hide-details
                                        dense
                                        v-model="pincode"
                                        outlined
                                        class="required"
                                    ></v-text-field>
                                    <InputError :data="error.pincode" />
                                </div>
                                <div class="billing-text-field">
                                    <v-text-field
                                        label="GSTN (if applicable)"
                                        hide-details
                                        v-model="gstn"
                                        dense
                                        outlined
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                        <div
                            class="subscription-details-col-input details-after-border"
                        >
                            <div class="order-details-box">
                                <div class="order-details-header">
                                    Your Order Details:
                                </div>
                                <div class="net-pay-val">
                                    Net Amount -
                                    {{
                                        renewalDetails &&
                                        renewalDetails.net_amount
                                            ? "₹ " +
                                              renewalDetails.net_amount +
                                              "/-"
                                            : "-"
                                    }}
                                </div>
                                <div class="net-pay-val" v-if="renewalDetails && renewalDetails.transaction_fee">
                                    Transaction Fee - {{"₹ " + renewalDetails.transaction_fee + "/-"}}
                                </div>
                                <div class="net-pay-val" v-if="renewalDetails && renewalDetails.platform_fee">
                                    Platform Fee - {{"₹ " + renewalDetails.platform_fee + "/-"}}
                                </div>
                                <div class="net-pay-val">
                                    GST @ 18% -
                                    {{
                                        renewalDetails && renewalDetails.gst
                                            ? "₹ " + renewalDetails.gst + "/-"
                                            : "-"
                                    }}
                                </div>
                                <div class="net-pay-val total-pay-val">
                                    <span>Total amount payable:</span
                                    ><span class="amount">{{
                                        renewalDetails &&
                                        renewalDetails.total_amount
                                            ? "₹ " +
                                              renewalDetails.total_amount +
                                              "/-"
                                            : "-"
                                    }}</span>
                                </div>
                            </div>
                            <div class="terms">
                                <v-checkbox v-model="isAgreed"></v-checkbox>
                                I agree with the
                                <a
                                    target="_blank"
                                    v-on:click="termandcondition"
                                >
                                    Terms & Conditions
                                </a>
                            </div>

                        <div class="subscription-details-col-2">
                            <v-btn
                                class="cust-btn"
                                color="primary"
                                @click="backRenew()"
                                >Back</v-btn
                            >
                            <v-btn
                                    class="cust-btn"
                                    @click="buyPackages()"
                                    :disabled="!isAgreed"
                                    color="primary"
                                    >Pay Now</v-btn
                             >
                        </div>
                            <div class="PayNow">
                                
                            </div>
                            <div class="invoice italics-styling">
                                The invoice shall be e-mailed to your registered
                                email address in 2 working days.
                            </div>
                        </div>
                    </div>

                    <div class="subscriptio-contact">
                        For any assistance contact us at
                        <a
                            class="italics-styling"
                            href="mailto: hello@eduracle.com"
                            >hello@eduracle.com</a
                        >
                    </div>
                </div>
            </div>
        </v-card>
        <PaymentHiddenInput :order="order"></PaymentHiddenInput>
        <AlertBox
            :width="modalwidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="alertBoxData"
            :contentClass="contentClass"
            :success="success"
            :failure="failure"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";
import axios from 'axios'
import PaymentHiddenInput from "./PaymentHiddenInput.vue";
export default {
    name: "RenewSubscription",
    components:{
        PaymentHiddenInput
    },
    mounted() {
        // this.getInstituteDetails();
        this.checkForStatus();
        this.studentCount = this.myInstitute.student_count;
    },
    data() {
        return {
            subscription_data: {},
            allowed_end_date: "",
            studentCount: "",
            durationMonth: 12,
            orderId: 0,
            status: false,
            isAgreed: false,
            alertBoxData: {},
            modalwidth: "1000px",
            contentClass: "",
            cComponent:
                "components/coordinator/subscription-details/PaymentPopUp",
            name: "",
            state: "",
            pincode: null,
            address: "",
            city: "",
            gstn: "",
            //expectedCount: ''
            success: false,
            failure: false,
            renewalDetails: {},
            htmlcontent:'div',
            selectedModules: { QPD: false, SL: false },
            purchaseModule: [],
            error: {
                name: {
                    type: null,
                    message: null,
                },
                address: {
                    type: null,
                    message: null,
                },
                pincode: {
                    type: null,
                    message: null,
                },
                city: {
                    type: null,
                    message: null,
                },
                state: {
                    type: null,
                    message: null,
                },
                studentCount: {
                    type: null,
                    message: null,
                },
                durationMonth: {
                    type: null,
                    message: null,
                },
            },
            order: null,
        };
    },

    methods: {
        ...mapActions({
            // getInstituteDetails: "userStore/getInstituteDetails",
            updateTransactionStatus: "userStore/updateTransactionStatus",
            createPackageOrder: "userStore/createPackageOrder",
            renewSubscription: "userStore/renewSubscription",
            me: "userStore/me",
        }),
        termandcondition() {
            let routeData = this.$router.resolve({
                name: "payment-terms-and-conditions",
            });
            window.open(routeData.href, "_blank");
        },
        backRenew() {
            this.$router.push({ name: "subscription-details" });
        },
        buyPackages() {
            if (this.validate()) {
                this.$root.showLoader = true;
                let success_redirect = window.location.href.split("?")[0];
                let failure_redirect = success_redirect;
                let reqData = {
                    success_redirect,
                    failure_redirect,
                    institute_id: this.myInstitute.id,
                    required_licence: parseInt(this.studentCount),
                    subscription_duration: this.durationMonth,
                    licence_purchase_type: constants.LICENSE_PURCHASED_TYPE.RENEW,
                    total_amount: this.renewalDetails.total_amount,
                    billing_details: {
                        name: this.name,
                        address: this.address,
                        city: this.city,
                        pincode: this.pincode,
                        gstn: this.gstn,
                        state: this.state,
                    },
                };

                if (this.renewModuleId) {
                    reqData.module_ids = [this.renewModuleId];
                } else {
                    reqData.product_ids = constants.PRODUCT_IDS_FOR_PURCHASE;
                }

                sessionStorage.setItem(
                    "purchaseDetails",
                    JSON.stringify(reqData)
                );
                sessionStorage.setItem(
                    "renewalDetails",
                    JSON.stringify(this.renewalDetails)
                );
                this.createPackageOrder(reqData)
                    .then((response) => {
                        this.$root.showLoader = false;
                        // this.order = response.order;
                        this.generateDataForPayment(response.order);
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$root.showLoader = false;
                    });
            }
        },
        async generateDataForPayment(order) {
            this.orderId = order.tx_id;
            let phoneNumber = this.user.phone;
            //phoneNumber = phoneNumber[1];
            let pd = {
                key: order.key,
                txnid: order.tx_id + "",
                amount: order.amount,
                firstname: this.user.name,
                email: this.user.email,
                phone: phoneNumber,
                productinfo: "" + order.productsForPurchase,
                surl: order.surl,
                furl: order.furl,
                hash: order.hash,
                mode: "dropout",
                udf1: order.udf1,
                udf2: order.udf2,
                udf3: order.udf3,
                udf5: "",
                pg_url:order.pg_url
            };
            this.order = pd;

            // this.launchBOLT(pd);
        },
        launchBOLT(pd) {
            let that = this;
            let handler = {
                responseHandler: function(BOLT) {
                    that.checkTransactionStatus(BOLT);
                },
                catchException: function(BOLT) {
                    that.handleBoltError(BOLT);
                },
            };

            bolt.launch(pd, handler);
        },
        handleBoltError(BOLT) {
            this.$toasted.error(BOLT.message);
        },
        checkTransactionStatus(BOLT) {
            if (BOLT.response.txnStatus == "CANCEL") {
                let postData = {
                    order_id: this.orderId,
                };
                this.updateTransactionStatus(postData)
                    .then((response) => {
                        // this.getPackagesList();
                        this.isAgreed = false;
                        this.$toasted.success("Transaction Cancelled by User.");
                    })
                    .catch((err) => {
                        this.$toasted.error(
                            "Error while updating transaction status."
                        );
                    });
            }
        },
        currentAmount() {
            var currentAmount = 0;
            this.packages.forEach((pkg) => {
                if (pkg.isAdded) currentAmount += parseInt(pkg.price);
            });
            return currentAmount;
        },
        checkForStatus() {
            // this.$route.query
            var status = this.$route.query.status;
            if (status && status.toUpperCase() == "SUCCESS") {
                this.$root.showLoader = true;
                if (this.myInstitute) {
                    setTimeout(() => {
                        this.$root.showLoader = false;
                        this.onDialogSuccessOpen(true);
                    }, 1000);
                } else {
                    this.$watch('myInstitute', (newValue) => {
                        if (newValue) {
                            this.$root.showLoader = false;
                            this.onDialogSuccessOpen(true);
                        }
                    });
                }
                // this.$toasted.success("Transaction Successful.");
            } else if (status && status.toUpperCase() == "FAILED") {
                this.onDialogFailureOpen(true);
                // this.$toasted.error("Transaction Failed.");
            }
            if (status) {
                window.history.pushState({}, document.title, this.$route.path);
            }
        },
        onDialogSuccessOpen(success) {
            let purchaseDetails = JSON.parse(
                sessionStorage.getItem("purchaseDetails")
            );
            this.renewalDetails = JSON.parse(
                sessionStorage.getItem("renewalDetails")
            );
            sessionStorage.removeItem('renewalDetails')
            this.cComponent =
                "components/coordinator/subscription-details/PaymentPopUp";
            this.modalwidth = "580px";
            this.contentClass = "modal-top-success";
            this.status = true;
            this.success = success;
            this.failure = false;
            this.alertBoxData = {
				...purchaseDetails,
				renewal: this.renewalDetails,
                selected_new_module: this.myInstitute.selected_new_module,
            };
			
        },
        onDialogFailureOpen(failure) {
            let purchaseDetails = JSON.parse(
                sessionStorage.getItem("purchaseDetails")
            );
            this.cComponent =
                "components/coordinator/subscription-details/PaymentPopUp";
            this.modalwidth = "580px";
            this.contentClass = "modal-top-failure";
            this.status = true;
            this.failure = failure;
            this.success = false;
            this.alertBoxData = purchaseDetails;
        },
        onClose(data) {
            this.status = data.status;
            if (data && data.failure && data.data && data.retry) {
                this.name = data.data.billing_details.name;
                this.address = data.data.billing_details.address;
                this.city = data.data.billing_details.city;
                this.pincode = data.data.billing_details.pincode;
                this.gstn = data.data.billing_details.gstn;
                this.state = data.data.billing_details.state;
                this.additionalStudent = data.data.required_licence;
                this.buyPackages();
            }
        },

        validate() {
            let isValid = true;
            this.error.name.type = null;
            this.error.address.type = null;
            this.error.pincode.type = null;
            this.error.state.type = null;
            this.error.city.type = null;
            this.error.durationMonth.type = null;
            if (!this.name || this.name.trim().length < 1) {
                this.error.name.type = "error";
                this.error.name.message = "Please enter name";
                isValid = false;
            }
            if (!this.city || this.city.length < 1) {
                this.error.city.type = "error";
                this.error.city.message = "Please enter city.";
                isValid = false;
            }
            if (!this.state || this.state.length < 1) {
                this.error.state.type = "error";
                this.error.state.message = "Please enter state.";
                isValid = false;
            }
            if (!this.address || this.address.length < 1) {
                this.error.address.type = "error";
                this.error.address.message = "Please enter address.";
                isValid = false;
            }
            if (!this.pincode || this.pincode.length < 1) {
                this.error.pincode.type = "error";
                this.error.pincode.message = "Please enter pincode.";
                isValid = false;
            } else {
                if (!/^[0-9]+$/.test(this.pincode)) {
                    this.error.pincode.type = "error";
                    this.error.pincode.message = "Please enter valid pincode";
                    isValid = false;
                }
            }
            if (!this.durationMonth || this.durationMonth < 1) {
                this.error.durationMonth.type = "error";
                this.error.durationMonth.message = "Please enter duration.";
                isValid = false;
            } else if (this.durationMonth && this.durationMonth % 3 !== 0) {
                this.error.durationMonth.type = "error";
                this.error.durationMonth.message =
                    "Duration must be in multiple of 3.";
                isValid = false;
            }
            return isValid;
        },
        renewLicensesChanges() {
            if (this.validateduration()) {
                let reqData = {
                    institute_id: this.myInstitute.id,
                    required_licence: parseInt(this.studentCount),
                    subscription_duration: parseInt(this.durationMonth),
                    module_id: this.renewModuleId,
                };
                this.renewSubscription(reqData)
                    .then((response) => {
                        if (response && response.code === 204) {
                            this.$toasted.error(response.message);
                            this.durationMonth =
                                response &&
                                response.required_subscription_duration
                                    ? response.required_subscription_duration
                                    : this.durationMonth;
                            this.studentCount =
                                response &&
                                response.approved_student &&
                                response.approved_student > this.studentCount
                                    ? response.approved_student
                                    : this.studentCount;
                        } else {
                            this.renewalDetails = response;
                            this.renewalDetails.renewal_expiry_date = moment(
                                this.renewalDetails.renewal_expiry_date
                            ).format("DD-MMM-YYYY");
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        getExpiryDate() {
            return moment(this.myInstitute.expiry_date).format(
                "DD - MMM - YYYY"
            );
        },
        validateduration() {
            let isValid = true;
            this.error.durationMonth.type = null;

            if (!this.durationMonth || this.durationMonth < 1) {
                this.error.durationMonth.type = "error";
                this.error.durationMonth.message = "Please enter duration.";
                isValid = false;
            } else if (this.durationMonth && this.durationMonth % 12 !== 0) {
                this.error.durationMonth.type = "error";
                this.error.durationMonth.message =
                    "Duration must be in multiple of 12.";
                isValid = false;
            }
            return isValid;
        },
    },
    computed: {
        ...mapState("userStore", ["user", "myInstitute"]),
        renewModuleId() {
            return Number(sessionStorage.getItem("renewModule")) || 0;
        },
        subscriptionNewModule() {
            if (!this.myInstitute.selected_new_module || !this.myInstitute.selected_new_module.length) return [];
            const now = moment();

            const retMod = this.myInstitute.selected_new_module
                .find(subInfo => Number(subInfo.module_id) === this.renewModuleId);

            if (!retMod) return null;

            const endDate = moment(retMod.expiry_date);

            return {
                allowed_end_date: endDate.format("DD - MMM - YYYY"),
                ...retMod,
            };
        },
    },

    watch: {
        name() {
            this.error.name.type = null;
        },
        city() {
            this.error.city.type = null;
        },
        pincode() {
            this.error.pincode.type = null;
        },
        address() {
            this.error.address.type = null;
        },
        state() {
            this.error.state.type = null;
        },
        studentCount(val) {
            this.error.studentCount.type = null;
            if (val != 0 || val.length > 0) {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(() => {
                    this.renewLicensesChanges(val);
                }, 300);
            } else {
                this.billingDetails = {};
            }
        },
        durationMonth(val) {
            this.error.durationMonth.type = null;
            if (val != 0 || val.length > 0) {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(() => {
                    this.renewLicensesChanges(val);
                }, 300);
            } else {
                this.billingDetails = {};
            }
        },
    },
};
</script>
